import React from "react";
import { Sparkles } from "lucide-react";
import { serviceIconMap } from "../../lib/constants";

export const ServiceIcon = ({ slug, size = 22 }) => {
  const Icon = serviceIconMap[slug] || Sparkles;
  return <Icon size={size} />;
};
